import png1 from '../assets/img/produkt/x50.jpg';
import png1_2 from '../assets/img/produkt/x50sp.jpg';
import png2 from '../assets/img/produkt/s30.jpg';
import png2_2 from '../assets/img/produkt/s30sp.jpg';
import png3 from '../assets/img/produkt/k10.jpg';
import png3_2 from '../assets/img/produkt/k10sp.jpg';
import {ISwitchButtonsOptions} from "../components/UI/SwitchButtons/SwitchButtons";
export interface IProduktCard {
  id: string;
  title: string;
  img: string[];
  description?: string;
  link: string;
}

export const PRODUKT_CARDS: IProduktCard[] = [
  {
    id: '0',
    title: 'X50',
    img: [png1, png1_2],
    link: 'https://basi.eu/wp-content/uploads/2025/09/info-basi-system-x50.pdf',
  },
  {
    id: '1',
    title: 'S30',
    img: [png2, png2_2],
    link: 'https://basi.eu/wp-content/uploads/2025/09/info-basi-system-s30.pdf',
  },
  {
    id: '2',
    title: 'K-10',
    img: [png3, png3_2],
    link: 'https://basi.eu/wp-content/uploads/2025/09/info-basi-system-k10.pdf',
  },
];

export const defaultProductType = 'werksprofil';

export const PRODUCT_TYPES: ISwitchButtonsOptions[] = [
  {
    name: 'Werksprofil',
    value: 'werksprofil',
  },
  {
    name: 'Sonderprofil',
    value: 'sonderprofil',
  },
];
